import { Collapse, UiDiv, UiText } from '@webfox-sc/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import IconArrowDown from '../../../assets/icons-v2/IconArrowDown';
import IconArrowUp from '../../../assets/icons-v2/IconArrowUp';
import IconButton from '../../atoms-v2/IconButton';

import { useTheme } from 'styled-components';
import { useCheckitemgrouptype } from '../../../app/entityHooks/useCheckitemgrouptype';
import BaseDataQMCheckitemgrouptypeForm from './BaseDataQMCheckitemgrouptypeForm';

interface BaseDataQMCheckitemtypeProps {
  checkitemgrouptypeId: number | undefined;
}

const BaseDataQMCheckitemgrouptype: React.FC<BaseDataQMCheckitemtypeProps> = ({ checkitemgrouptypeId }) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { checkitemgrouptype } = useCheckitemgrouptype(checkitemgrouptypeId);

  const [showContent, setShowContent] = useState(false);

  if (!checkitemgrouptype) {
    return null;
  }

  return (
    <UiDiv>
      <UiDiv padding="15px" background="white" color="ciBlue1" cursor="pointer" onClick={() => setShowContent(!showContent)}>
        <UiDiv display="grid" gridTemplateColumns="1fr 22px" columnGap="s" alignItems="center">
          <UiText variant="copy" color={checkitemgrouptype.disabled ? colors.grey20 : 'default'}>
            <b>
              {checkitemgrouptype.name}
              {checkitemgrouptype.disabled && ` (${t('common.fields.deleted')})`}
            </b>
          </UiText>
          <IconButton icon={showContent ? IconArrowUp : IconArrowDown} />
        </UiDiv>
      </UiDiv>
      <Collapse show={showContent} fadeInOut keepChildren={false}>
        <UiDiv paddingTop="1px">
          <UiDiv padding="s" background="grey20">
            <BaseDataQMCheckitemgrouptypeForm
              checkitemgrouptypeId={checkitemgrouptype.id}
              onSubmit={() => setShowContent(false)}
              onClickCancel={() => setShowContent(false)}
            />
          </UiDiv>
        </UiDiv>
      </Collapse>
    </UiDiv>
  );
};

export default BaseDataQMCheckitemgrouptype;
